import { Alert, Flex } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { SettingsLabel } from "../../../controls/SettingsLabel";

type ImagesVideosTabHeaderProps = {
  title: string;
  warning?: string;
};

export const ImagesVideosTabHeader = ({
  title,
  warning,
}: ImagesVideosTabHeaderProps) => {
  const { theme } = useAntTheme();

  return (
    <Flex vertical gap={6}>
      <SettingsLabel>{title}</SettingsLabel>
      {warning && (
        <Alert
          showIcon
          message={warning}
          type="warning"
          style={{
            fontSize: theme.fontSizeSM,
            lineHeight: 1.2,
          }}
        />
      )}
    </Flex>
  );
};
